//regex from BE documentation: ^(position|createdAt|name|finalPrice|unitOfMeasurementFinalPrice|itemPrice)\|(asc|desc)$
export const SORT_OPTIONS = [
  'position|asc',
  'name|asc',
  'itemPrice|asc',
  'itemPrice|desc',
  'unitOfMeasurementFinalPrice|asc',
];

//regex from BE documentation: ^(name|price|unitOfMeasurementFinalPrice|score|discount)\|(asc|desc)$
export const SEARCH_SORT_OPTIONS = [
  'score|desc',
  'name|asc',
  'price|asc',
  'price|desc',
  'unitOfMeasurementFinalPrice|asc',
];
